import { Location } from "@reach/router";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import getRoutes from "./routes";
import AppLayout from "./components/layout/Layout";
import { User } from "./utils/helpers/types";
import UserContext from "./context/user-context";
import { getUsersAndPermissions } from "./utils/helpers/data/userAndPermissions";

const savedUserStr = localStorage.getItem("userData");
const savedUser = savedUserStr ? (JSON.parse(savedUserStr) as User) : null;
const notExpired = savedUser?.expiryDate
  ? dayjs(savedUser.expiryDate).isAfter(dayjs().subtract(6, "hour"))
  : false;

const App: FunctionComponent = () => {
  const [user, setUser] = useState<User | null>(notExpired ? savedUser : null);
  const [waitingMessage, setWaitingMessage] = useState("Loading. . .");

  const contextValue = useMemo(() => ({ user, setUser }), [user]);

  useEffect(() => {
    const fetchUserAndPermissions = async () => {
      const response = await getUsersAndPermissions();
      if (response.error) {
        setWaitingMessage(
          "Unable to load application. Please contact your administrator"
        );
        return;
      }
      setUser(response.data);
    };

    fetchUserAndPermissions();
  }, []);

  return user ? (
    <UserContext.Provider value={contextValue}>
      <Location>
        {({ location }) => (
          <AppLayout location={location}>{getRoutes(user)}</AppLayout>
        )}
      </Location>
    </UserContext.Provider>
  ) : (
    <div>{waitingMessage}</div>
  );
};

export default App;
